var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Demo'),_c('FeaturesTheApp'),_c('PricingPlan'),_c('AppScreenshots'),_c('SomeTalkOfOurClients'),_c('SayHelloToUs'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }